<script setup lang="ts">
type Props = {
  pills?: Pill[];
};

const { pills } = defineProps<Props>();

const emit = defineEmits<{
  (e: "clear-filters"): void;
  (e: "clear-single-filter", pill: Pill): void;
}>();

const onClearFilters = () => {
  emit("clear-filters");
};

const onClearSingleFilter = (pill: Pill) => {
  emit("clear-single-filter", pill);
};
</script>

<template>
  <div
    class="p-4 md:pl-0 md:pt-0 flex flex-wrap gap-2 items-center"
    data-test="filter-pill-container"
  >
    <ProductFilterPill
      :label="$t('filter.clearFilters')"
      @click="onClearFilters"
    />

    <ProductFilterPill
      v-for="pill in pills"
      :key="pill.value"
      :label="pill.label"
      :has-close-button="true"
      @click="onClearSingleFilter(pill)"
    />
  </div>
</template>
